export default import.meta.ROLLDOWN_FILE_URL_dh09x6pf3caCnYAo_0idfw